/* eslint-disable import/no-cycle */
import { getI18nLanguage } from '@/plugins/i18n'
import { apiHttp } from '../axiosApi'
import {
  fieldAll,
  fieldByFacility,
  fieldApp,
} from '../config/apiRoute'

export const getFields = () => apiHttp('GET', `${fieldAll}`, null, {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Basic ${btoa('')}`,
    'Accept-Language': getI18nLanguage(),
  },
})
export const getFieldsByFacility = id => apiHttp('GET', `${fieldByFacility}${id}`, null, {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Basic ${btoa(`${id}`)}`,
    'Accept-Language': getI18nLanguage(),
  },
})

// Public page behind the QR codes printed at the fields (moved here from the
// retired Console, which served /field-app/:id).
export const getFieldApp = id => apiHttp('GET', `${fieldApp}${id}`)
